export default ".last-activity {\n  margin-top: 5px;\n}";